import type { ReactNode } from 'react'
import { cn } from '../cn'

export interface EmptyStateProps {
  title: ReactNode
  description?: ReactNode
  /** Decorative icon (lucide). */
  icon?: ReactNode
  /** Buttons or links. */
  action?: ReactNode
  /** `plain` drops the dashed frame, for use inside a card or table. */
  variant?: 'framed' | 'plain'
  className?: string
}

export function EmptyState({
  title,
  description,
  icon,
  action,
  variant = 'framed',
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center px-6 py-12 text-center',
        variant === 'framed' && 'rounded-lg border border-dashed border-line-strong bg-surface/70',
        className,
      )}
    >
      {icon ? (
        <div
          aria-hidden="true"
          className="mb-4 flex size-12 items-center justify-center rounded-full bg-wash text-teal-500 ring-1 ring-line [&>svg]:size-[22px]"
        >
          {icon}
        </div>
      ) : null}
      <p className="font-display text-base font-semibold text-ink">{title}</p>
      {description ? (
        <p className="mt-2 max-w-md text-sm leading-relaxed text-sage">{description}</p>
      ) : null}
      {action ? <div className="mt-5 flex flex-wrap justify-center gap-2.5">{action}</div> : null}
    </div>
  )
}
